export default {
  listTitleTable: {
    COM_GROUP_CODE: 'MÃ',
    MATCH_PRICE: 'GIÁ KHỚP',
    PERCENT_PRICE_CHANGE: '1 NGÀY',
    PERCENT_PRICE_CHANGE_1WEEK: '1 TUẦN',
    PERCENT_PRICE_CHANGE_1MONTH: '1 THÁNG',
    PERCENT_PRICE_CHANGE_3MONTH: '3 THÁNG',
    PERCENT_PRICE_CHANGE_6MONTH: '6 THÁNG',
    PERCENT_PRICE_CHANGE_9MONTH: '9 THÁNG',
    PERCENT_PRICE_CHANGE_1YEAR: '1 NĂM',
    PERCENT_PRICE_CHANGE_YTD: 'TỪ ĐẦU NĂM',
  },
};
